import { API_BASE } from "./api";
import { getMyAccountId, isBMI } from "./config";

export async function duplicateOrder(order, items, { history = null, setCartItems = null } = {}) {
    if (!order || !items) return;

    const MYACCOUNT_ID = getMyAccountId();
    const user = JSON.parse(localStorage.getItem("user"));
    const idCustomer = order.idCustomer || user.idCustomer;
    const porcentaje = Number(user.porcentaje);

    const updatedItems = [];

    const isProforma = order.tipo === "PE" && order.clase === " ";

    for (const i of items) {
        try {
            if (isProforma) {
                const qty = Number(i.quantity);
                const subtotalRaw = qty * i.unitPrice;
                const subtotalCents = Math.round((subtotalRaw + Number.EPSILON) * 100);
                const st = (subtotalCents / 100).toFixed(2);
                const payTax = Number(i.taxValue) > 0;
                const tax = payTax
                    ? (Math.round((subtotalCents * (porcentaje / 100)) + Number.EPSILON) / 100).toFixed(2)
                    : "0.00";

                updatedItems.push({
                    img: `https://www.ultra-erp.pro/products/${MYACCOUNT_ID}/${i.productId}.jpg`,
                    idProduct: i.idProduct,
                    code: i.productId,
                    description: i.productName,
                    notes: i.notes || null,
                    price: i.unitPrice,
                    qty,
                    subtotal: st,
                    payTax,
                    tax,
                    service: i.service ?? false,
                    acuerdo: i.acuerdo ?? false,
                });
                continue;
            }

            const res = await fetch(
                `${API_BASE}/inventary-ultra/api/ws/search_products_api?myaccount_id=${MYACCOUNT_ID}&bodega_id=${user.bodegaId}&id_customer=${idCustomer}&search=${i.productId}&solo_acuerdo=${isBMI({ idCustomer })}`
            );

            const data = await res.json();
            if (!data || data.length === 0) continue;

            const p = data[0];
            const qty = Number(i.quantity);
            const subtotalRaw = qty * p.unitPrice;
            const subtotalCents = Math.round((subtotalRaw + Number.EPSILON) * 100);
            const st = (subtotalCents / 100).toFixed(2);
            const taxValue = p.payTax
                ? (Math.round((subtotalCents * (porcentaje / 100)) + Number.EPSILON) / 100).toFixed(2)
                : "0.00";

            updatedItems.push({
                img: `https://www.ultra-erp.pro/products/${MYACCOUNT_ID}/${p.productId}.jpg`,
                idProduct: p.idProduct,
                code: p.productId,
                description: p.productName,
                notes: i.notes || null,
                price: p.unitPrice,
                qty,
                subtotal: st,
                payTax: p.payTax,
                tax: taxValue,
                service: p.service,
                acuerdo: p.acuerdo ?? i.acuerdo ?? false,
            });
        } catch (err) {
            console.error("Error duplicando pedido:", err);
        }
    }

    if (setCartItems) setCartItems(updatedItems);
    order.notes = `DUPLICADO DESDE ${order.orderNumber}`;
    localStorage.setItem("order_express_items", JSON.stringify(updatedItems));

    if (history) {
        history.push("/order-express");
    } else {
        window.location.href = "/order-express";
    }
}
